import React from 'react';

const formatPrice = (price) => {
  if (!price) return "Check Price";
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0, 
  }).format(price);
};

export default function ProductCard({ product }) {
  if (!product) return null;

  const displayName = (product.model && product.model !== "null") 
    ? product.model 
    : `${product.brand} Laptop`;
    
  const imageUrl = product.image || product.img_url || product.thumbnail;

  return (
    <div className="bg-white p-4 rounded-2xl border border-stone-200 shadow-sm flex flex-col gap-3 min-w-[260px] md:min-w-[300px] hover:shadow-md transition-shadow">
      
      {/* 1. IMAGE AREA */}
      <div className="h-[160px] w-full flex items-center justify-center p-2 bg-stone-50 rounded-xl relative group">
        {imageUrl ? (
          <img 
            src={imageUrl} 
            alt={displayName} 
            className="max-h-full max-w-full object-contain mix-blend-multiply transition-transform transform group-hover:scale-105" 
            onError={(e) => e.target.style.display = 'none'}
          />
        ) : (
          <span className="text-stone-400 text-xs">No Image</span>
        )}
      </div>

      <div className="flex flex-col gap-2">
        {/* 2. TITLE & PRICE */}
        <div className="flex justify-between items-start gap-2">
            <h3 className="font-bold text-stone-800 text-sm leading-tight line-clamp-2">
            {product.brand} <span className="font-normal text-stone-600">{displayName}</span>
            </h3>
            <span className="font-bold text-green-700 text-base shrink-0">
                {formatPrice(product.price)}
            </span>
        </div>

        {/* 3. SUMMARY / PITCH (The new part!) */}
        {product.pitch && (
            <div className="bg-blue-50/50 p-2.5 rounded-lg border border-blue-100/50">
                <p className="text-[13px] leading-relaxed text-stone-600">
                    {product.pitch}
                </p>
            </div>
        )}

        {/* 4. BUTTON */}
        <a 
          href={product.url} 
          target="_blank" 
          rel="noopener noreferrer"
          className="mt-1 w-full text-center bg-stone-900 hover:bg-black text-white text-xs font-semibold px-4 py-2.5 rounded-lg transition-all active:scale-95"
        >
          View Deal
        </a>
      </div>
    </div>
  );
}